import {
  TBCTXKeys,
  TPaginationInfo,
  TPerPieceLineInTransactionItem,
  TPerPieceLineInTransactionItemWithModifiedLinkedVId,
  TPerPieceLineTransactionsListingItemFilter,
  TUserPaginationOption,
} from '@monorepo/types';
import { TFilterGroupModel, UiFilterModifiers } from '@monorepo/ui';
import * as _ from 'lodash';

export const PER_PIECE_LINE_IN_TRANSACTIONS_SELECTION_FILTER_MODEL = {
  createModel: (
    items: TPerPieceLineTransactionsListingItemFilter[],
    bctxKeysToDisplayMap: Record<TBCTXKeys, string>,
    prevModel?: TFilterGroupModel<TPerPieceLineTransactionsListingItemFilter>,
    minCharacterLength?: Record<TBCTXKeys, number>,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      const limitItemsByKeystroke: number = minCharacterLength
        ? minCharacterLength[item.filterType as TBCTXKeys] || 0
        : 0;
      return {
        type: 'SELECT_FILTER',
        key: item.filterType,
        displayName: bctxKeysToDisplayMap[item.filterType],
        items: item.values.map((val) => {
          return {
            value: val,
            isSelected: false,
          };
        }),
        selectedValues: [],
        limitItemsByKeystroke: limitItemsByKeystroke || undefined,
      };
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
  getFilteredTransactions: (
    selectedFilters: TPerPieceLineTransactionsListingItemFilter[],
    defectList: TPerPieceLineInTransactionItemWithModifiedLinkedVId[],
    orderKeys: TBCTXKeys[],
    userPaginationOption: TUserPaginationOption,
  ) => {
    const rangeInPageStart = (userPaginationOption.pageNo - 1) * userPaginationOption.pageSize + 1;
    const rangeInPageEnd = userPaginationOption.pageNo * userPaginationOption.pageSize;

    const filteredDefectList: TPerPieceLineInTransactionItemWithModifiedLinkedVId[] = [];
    defectList.forEach((event) => {
      const itemInfo = event;
      let isFiltered = true;
      selectedFilters.forEach((selectedFilter) => {
        if (selectedFilter.values.length) {
          isFiltered =
            isFiltered &&
            selectedFilter.values.some((f) =>
              itemInfo.item.bctx_items.some((item) => item.k === selectedFilter.filterType && item.v === f),
            );
        }
      });
      if (isFiltered) filteredDefectList.push({ ...event });
    });
    const supportedFilters: TPerPieceLineTransactionsListingItemFilter[] = [];
    orderKeys.forEach((key) => {
      supportedFilters.push({
        filterType: key as TPerPieceLineTransactionsListingItemFilter['filterType'],
        values: _.uniq(
          filteredDefectList.reduce((acc, bctxListItem) => {
            const itemInfo = bctxListItem.item.bctx_items.find((item) => item.k === key);
            if (itemInfo) acc.push(itemInfo.v);
            return acc;
          }, [] as string[]),
        ),
      });
    });

    const paginatedFilteredActivityLog: TPerPieceLineInTransactionItemWithModifiedLinkedVId[] =
      filteredDefectList.slice(rangeInPageStart - 1, rangeInPageEnd);
    const paginationInfo: TPaginationInfo = {
      itemsPerPage: userPaginationOption.pageSize,
      rangeInPage: {
        start: rangeInPageStart,
        end: rangeInPageEnd,
      },
      totalItems: filteredDefectList.length,
      totalPageCount: PER_PIECE_LINE_IN_TRANSACTIONS_SELECTION_FILTER_MODEL.getTotalPageCount(
        filteredDefectList.length,
        userPaginationOption.pageSize,
      ),
    };
    return {
      supportedFilters,
      paginatedFilteredActivityLog,
      paginationInfo,
    };
  },

  getTotalPageCount: (totalItems: number, itemsPerPage: number) => {
    return Math.ceil(totalItems / itemsPerPage);
  },
};
